// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "5e3fcbca" + "." + "fd48d16b37acb724" + ".js";
};